import { InlineImage } from "../../components/InlineImage";

export default function Day05() {
  return (
    <div className="box light">
      <div className="row">
        <h1>Dag 5 - 15 juli</h1>
        <h2>La Palmera</h2>

        <InlineImage width="25%" image="costarica/dag05-02.jpg" webp float="right" />
        <p>
          We zijn toe aan een dagje rust. Toch zijn we alweer vroeg wakker, en dat komt onder meer doordat we altijd vroeg naar bed gaan. Bij zonsopgang horen we de brulapen
          bulderen, verderop in het regenwoud waar het huisje tegenaan staat. Dat geluid zullen we hier elke ochtend horen, altijd bij zonsopgang. Het huisje heeft geen ramen, maar
          gaten met horren, waardoor de geluiden extra goed te horen zijn. Gelukkig hangen overal ventilatoren, want ook hier is het warm en vochtig. In de nacht heeft het veel
          geregend en geonweerd. En zonder ramen hoor je dat ook best goed – toch wel een beetje spannend.
        </p>
        <InlineImage width="20%" image="costarica/dag05-01.jpg" webp float="left" />
        <p>
          Het enige uitstapje vandaag is naar de supermarkt en de pinautomaat. Omdat veel van onze was nat is, laten we ook een wasje draaien. Dat kost $5 per lading. Best duur,
          denken we dan nog, maar later komen we erachter dat het nog heel veel duurder kan. Onze was wordt in ieder geval netjes gewassen en gedroogd, dus we kunnen er weer even
          tegenaan.
        </p>
        <InlineImage width="20%" image="costarica/dag05-04.jpg" webp float="right" />
        <p>
          Vanuit het huisje hebben we een mooi uitzicht en zien we allerlei dieren. In een boom iets verderop zitten wilde kalkoenen – de variant die niet door de mens is
          gedomesticeerd en nog wel kan vliegen. Ook spotten we enkele toekans. Beneden is een soort vlindertuin met prachtige vlinders. De Blue Morpho (een hele grote blauwe
          vlinder) zien we ook, maar laat zich niet op de foto zetten.
        </p>
        <InlineImage width="15%" image="costarica/dag05-05.jpg" webp float="left" />
        <p>
          De deur van het huisje moet dichtgehouden worden om ongedierte buiten te houden. Maar die waarschuwing komt te laat: er glipt toch een beestje naar binnen. Later blijkt
          het een hagedis te zijn, die we Wilbert zijn gaan noemen. We zien hem met enige regelmaat ergens in de woonkamer of keuken zitten, maar krijgen hem niet te pakken. Als
          Ivo af gaat wassen en het keukenmes pakt, heeft Wilbert zich doodleuk vastgeplakt aan het lemmet. Wilbert lijkt het wel naar zijn zin te hebben in ons huisje.
        </p>
        <InlineImage width="30%" image="costarica/dag05-03.jpg" webp float="right" />
        <p>
          Ook vandaag gaan we uiteraard weer zwemmen en proberen we alle baden op het terrein uit. Er zijn vijftien verschillende baden met uiteenlopende temperaturen, en vaak
          heeft één bad meerdere delen met weer andere temperaturen. Het binnenste deel is dan het heetst, maar ook het kleinst. De baden bevatten alleen natuurlijk bronwater en
          worden elke dag volledig leeggemaakt, schoongemaakt en weer gevuld. Er stroomt ook een klein, warm riviertje over het terrein. En dit alles ligt midden in het regenwoud,
          waar je talloze dieren kunt spotten.
        </p>
        <p>
          Ook overdag regent het af en toe. Maar met deze temperaturen is dat niet zo erg. En als we toch gaan zwemmen, maakt het al helemaal niet uit. Als we in de avond weer gaan
          zwemmen is het rustig, heerlijk rustig.
        </p>
      </div>
    </div>
  );
}
